/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 4/21/13
 * Time: 8:04 AM
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var TasksManager = require('web-agent-lib/TasksManager');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var ViewController = require('web-agent-framework/ViewController');
    var lpWebAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var EmptyPlaceholderWidget = require('web-agent-widgets/EmptyPlaceholderWidget');

    var WidgetsManagerViewController = ViewController.extend({
        ControllerName: 'WidgetsManagerViewController',
        CUSTOM_WIDGET_KEYS: "CUSTOM_WIDGET_KEYS",
        CUSTOM_WIDGET_URL: "CUSTOM_WIDGET_URL_",
        DEFAULT_MIN_WIDTH: 288,
        DEFAULT_MAX_WIDTH: 360,
        WIDGETS_PADDING: 15,

        LPViewMap: {
            buttonsArea: ".lpview_buttons_area",
            contentArea: ".lpview_content_area",
            widgetsArea: ".lpview_widgets_area",
            contentAreaAnimate: ".lpview_content_area_animate",
            rightArrow: ".lpview_right_arrow",
            leftArrow: ".lpview_left_arrow",
            widgetTitle: ".lpview_widget_title",
            widgetIcon: ".lpview_title_icon",
            addButton: ".lpview_add_button",
            managedWidgetContent: ".lpview_managed_widget_content",
            closeButton: ".lpview_close_widget_icon",
            customWidgetIcon: ".custom_widget_icon",
            rightPaneWidgetTitle: '.right_pane_widget_title'
        },

        LPViewClasses: {
            selected: "selected",
            disabled: "disabled",
            notified: "notified"
        },

        widgetMode: {
            pilot: "test",
            publish: "publish"
        },

        initialize: function (constructorData) {
            this.startWidget = 0;
            this.endWidget = 0;
            this.customWidgets = [];
            this.widgetsDataArray = []; // Maps the data in array.
            this.widgetsData = {}; // Contains: applicationType, selected, widgetsArray
            this.engagementWidgets = {};
            this.autoHideButtonsToolbar = constructorData.autoHideButtonsToolbar;
            this.visibleWidgetsCount = 0;


            // reading the timeout from the config.
            var leConfig = agentLEManager.getLEConfig();
            var customWidgetsLEConfig = (leConfig && leConfig.customWidgets);

        this.taskManager = new TasksManager({
            taskTimeout: (customWidgetsLEConfig && customWidgetsLEConfig.loadTimeout) || ( 1000 * 20) ,
            maxParallelTasks: (customWidgetsLEConfig && customWidgetsLEConfig.maxParallelTasks) || 2,
            autoStart: true
        });
        var appEventsChannel = lpWebAgentStatics.COMMUNICATION_CHANNELS.AppEvents;
            lpTag.WebAgent.channel.bind(appEventsChannel.name, appEventsChannel.events.sdkNotification, this.onWidgetNotification.bind(this));},

        events: function () {
            this.bindModel({modelPath: "agent.status", callback: this.statusChanged});

            this.bindViewEvent({selector: window, DOMEvent: "resize", callback: this.resizeContent});

            this.bindViewEvent({selector: this.LPViewMap.leftArrow, DOMEvent: "click", callback: this.buttonClicked, lpEventData: {indexAddition: -1}});
            this.bindViewEvent({selector: this.LPViewMap.rightArrow, DOMEvent: "click", callback: this.buttonClicked, lpEventData: {indexAddition: 1}});
            this.bindViewEvent({selector: this.LPViewMap.addButton, DOMEvent: "click", callback: this.loadDynamicWidget});

        },

        render: function () {
            this.view.tabIndex = 1;
        }
    });

WidgetsManagerViewController.prototype.onWidgetNotification = function (data) {
    if(this.engagementWidgets && this.engagementWidgets[data.visitorId] && this.engagementWidgets[data.visitorId][data.applicationType]) {
        this.engagementWidgets[data.visitorId][data.applicationType].hasSdkNotifications = true;
        this.delayedLayoutWidgets();
    }
};

    WidgetsManagerViewController.prototype.buttonClicked = function (data) {
        this.startWidget += data.lpEventData.indexAddition;
        this.endWidget += data.lpEventData.indexAddition;

        if (this.startWidget < 0) {
            this.startWidget = 0;
        }
        if (this.endWidget >= this.widgetsDataArray.length) {
            this.endWidget = this.widgetsDataArray.length - 1;
        }

        this.delayedLayoutWidgets();
    };

    WidgetsManagerViewController.prototype.createPlaceholder = function (applicationType, iconClass, widgetConfig) {
        return new EmptyPlaceholderWidget({templateFile: "LP_right_pane_widget_no_data.html",
            widgetsManager: this,
            iconClass: iconClass,
            applicationType: applicationType,
            widgetConfig: widgetConfig || {}
        });
    };

    WidgetsManagerViewController.prototype.resizeContent = function (e) {
        this.delayedLayoutWidgets(true);
    };

    WidgetsManagerViewController.prototype.delayedLayoutWidgets = function (resizeEvent, onShowCallback) {
        var that = this;

        if (this.delayedLayoutTimeout) {
            clearTimeout(this.delayedLayoutTimeout);
            this.delayedLayoutTimeout = null;
        }
        this.delayedLayoutTimeout = setTimeout(function () {
            that.delayedLayoutTimeout = null;
            layoutWidgets(that, resizeEvent, onShowCallback);
        }, 10);

        ////////////////////////////////////////////////////////////////////////////////////////////////
        //////////////////////////////// Private functions starts here /////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////

        function layoutWidgets(context, resizeEvent, onShowCallback) {
            if (!context.visible) {
                return; // No layout on hidden view.
            }
            var visibleWidgetsContainers = context.getWidgetsForCurrentVisitor();

            var contentWidth = _getContentWidth(context);

            if (!hasContentWidth(context, contentWidth)) {
                return;
            }
            var animate = !resizeEvent;

            context.visibleWidgetsCount = context.getNumberOfActiveWidgets(visibleWidgetsContainers, contentWidth);
            updateStartAndEndPointers(context, visibleWidgetsContainers);
            setWidgetsWidth(context, visibleWidgetsContainers, contentWidth, context.visibleWidgetsCount, animate, onShowCallback);
            setButtonsEnabled(context, visibleWidgetsContainers);
            if (typeof context.autoHideButtonsToolbar !== 'undefined' && context.autoHideButtonsToolbar) { // this is only relevant to the visitor list widgets
                setWidgetsAreaWidth(context);
                toggleButtonsToolbar(context, visibleWidgetsContainers);
            }
        }

        function setWidgetsAreaWidth(context) {  // TODO: should be replaced once the VisitorFeedManager is set
            var widgetArea = context.getFirstElement(context.LPViewMap.widgetsArea);
            widgetArea.style.width = (context.visibleWidgetsCount * 360) + "px";
        }

        function toggleButtonsToolbar(context, visibleWidgetsContainers) {
            var allWidgetsVisible = (context.visibleWidgetsCount === visibleWidgetsContainers.length);
            var widgetArea = context.getFirstElement(context.LPViewMap.widgetsArea);
            if (allWidgetsVisible) {
                context.addClass(widgetArea, "expand_widgets");
            } else {
                context.removeClass(widgetArea, "expand_widgets");
            }
        }

        function hasContentWidth(context, contentWidth) {
            // This code is set to verify the widgets area is loaded before we try to layout it.
            // If its not loaded, then the width of the content area is less or equals to zero.
            if (typeof contentWidth !== 'number' || contentWidth < 0) {
                if (context.layoutTimeout) {
                    clearTimeout(context.layoutTimeout);
                }
                context.layoutTimeout = setTimeout(function () {
                    context.delayedLayoutWidgets.call(context);
                }, 50);
                return false;
            }
            return true;
        }

        function updateStartAndEndPointers(context, widgetsArray) {
            context.endWidget = context.startWidget + context.visibleWidgetsCount;
            if (context.endWidget > widgetsArray.length) {
                context.endWidget = widgetsArray.length;
                context.startWidget = context.endWidget - context.visibleWidgetsCount;
            }
        }

        function setButtonsEnabled(context, widgetsArray) {
            var leftArrow = context.getFirstElement(context.LPViewMap.leftArrow);
            var rightArrow = context.getFirstElement(context.LPViewMap.rightArrow);
            var hasArrows = leftArrow && rightArrow;
            var leftEnabled = _canMoveBack(context, widgetsArray);
            var rightEnabled = _canMoveForward(context, widgetsArray);

            if (hasArrows) {
                enableDisableArrows(context, leftArrow, rightArrow, leftEnabled, rightEnabled);
                showHideArrows(context, leftArrow, rightArrow, leftEnabled, rightEnabled);
            }
        }

        function showHideArrows(context, leftArrow, rightArrow, leftEnabled, rightEnabled) {
            if (leftEnabled || rightEnabled) {
                context.lpShow(leftArrow);
                context.lpShow(rightArrow);
            } else {
                context.lpHide(leftArrow);
                context.lpHide(rightArrow);
            }
        }

        function enableDisableArrows(context, leftArrow, rightArrow, leftEnabled, rightEnabled) {
            if (leftEnabled) {
                context.removeClass(leftArrow, context.LPViewClasses.disabled);
                leftArrow.removeAttribute(context.LPViewClasses.disabled);
            } else {
                context.addClass(leftArrow, context.LPViewClasses.disabled);
                leftArrow.setAttribute(context.LPViewClasses.disabled, context.LPViewClasses.disabled);
            }

            if (rightEnabled) {
                context.removeClass(rightArrow, context.LPViewClasses.disabled);
                rightArrow.removeAttribute(context.LPViewClasses.disabled);
            } else {
                context.addClass(rightArrow, context.LPViewClasses.disabled);
                rightArrow.setAttribute(context.LPViewClasses.disabled, context.LPViewClasses.disabled);
            }
        }

        function setWidgetsWidth(context, widgetsArray, contentWidth, numberOfActiveWidgets, animate, onShowCallback) {
            var actualContentWidth = 0;
            var actualPositionWidget = 0;
            var amountOfActualWidgets = _getWidgetsMultipliers(context, widgetsArray);
            var singleWidgetWidth = _getSingleWidgetWidth(context, contentWidth, numberOfActiveWidgets, amountOfActualWidgets);
            var leftPosition = calculateActualWidth(context, widgetsArray, singleWidgetWidth);

            for (var index = 0; index < widgetsArray.length; index++) {
                var widgetContainer = widgetsArray[index];
                var showView = index >= context.startWidget && index < context.endWidget;

                actualContentWidth += widgetContainer.calculatedWidth ? Math.min(widgetContainer.minWidth, widgetContainer.actualWidth) : widgetContainer.actualWidth;
                var contentArea = context.getFirstElement(context.LPViewMap.contentArea);
                var content = context.getFirstElement("." + widgetContainer.applicationType, contentArea);

                if (animate) {
                    context.animate(content, {duration: 300, opacity: showView ? "1" : "0"}, createAnimationCallback(context, widgetContainer, showView));
                }
                else {
                    content.style.opacity = showView ? "1" : "0";
                }

                if (showView) {
                    context.showWidgetContent(widgetContainer);
                } else if (!animate && !showView) {
                    context.hideWidgetContent(widgetContainer);
                }
                var customMinWidth = widgetContainer.calculatedWidth ? widgetContainer.calculatedWidth : widgetContainer.minWidth;
                widgetContainer.contentArea.style.minWidth = customMinWidth + "px";
                widgetContainer.contentArea.style.maxWidth = widgetContainer.maxWidth + "px";

                widgetContainer.contentArea.style.width = widgetContainer.actualWidth + "px";
                widgetContainer.contentArea.style.left = actualPositionWidget + "px";
                var widthToAdd = widgetContainer.calculatedWidth ? Math.min(widgetContainer.minWidth, widgetContainer.actualWidth) : widgetContainer.actualWidth;
                actualPositionWidget += (widthToAdd + context.WIDGETS_PADDING);
            }
            var animateView = context.getFirstElement(context.LPViewMap.contentAreaAnimate);
            animateView.style.width = actualContentWidth + "px";

            var callbackFunc = createCallbackFunc(context, widgetsArray, onShowCallback);
            if (animate) {
                context.animate(animateView, {duration: 300, left: (-1 * leftPosition) + "px"}, callbackFunc);
            } else {
                animateView.style.left = (-1 * leftPosition) + "px";
                callbackFunc();
            }

            return actualContentWidth;

            function calculateActualWidth(context, widgetsArray, singleWidgetWidth) {
                var left = 0;
                for (var i = 0; i < widgetsArray.length; i++) {
                    var widget = widgetsArray[i];

                    var widgetWidth = singleWidgetWidth * widget.widgetMultiplier;
                    widgetWidth = Math.min(widget.maxWidth, widgetWidth);
                    widgetWidth = Math.max(widget.minWidth, widgetWidth);

                    widget.actualWidth = widget.calculatedWidth ? widget.calculatedWidth : widgetWidth;
                    if (i < context.startWidget) {
                        left += widget.actualWidth + context.WIDGETS_PADDING;
                    }
                }

                return left;
            }

            function createAnimationCallback(context, wContainer, showView) {
                function showCallback() {
                    context.showWidgetContent(wContainer);
                }

                function hideCallback() {
                    context.hideWidgetContent(wContainer);
                }

                return showView ? showCallback : hideCallback;
            }

        }

        function createCallbackFunc(context, widgetsArray, onShowCallback) {
            return function () {
                for (var index = 0; index < widgetsArray.length; index++) {
                    var widget = widgetsArray[index];
                    var showView = index >= context.startWidget && index < context.endWidget;
                    if (!showView) {
                        context.hideWidgetContent(widget);
                    }
                }
                if (onShowCallback) {
                    onShowCallback.call(context);
                }
            };
        }
    };

    WidgetsManagerViewController.prototype.SdkNotificationOnWidgetExistForCurrentVisitor = function (widgetInstances) {
        var that = this;
        return _.findIndex(widgetInstances, isCurrentVisitorHasSdkNotification) !== -1;

        function isCurrentVisitorHasSdkNotification(widget) {
            return widget.visitorId === that.focusedVisitorId && widget.hasSdkNotifications;
        }
    };
    WidgetsManagerViewController.prototype.getWidgetsForCurrentVisitor = function () {
        var visibleWidgets = [];
        var index;
        for (index = 0; index < this.widgetsDataArray.length; index++) {
            if (!this.widgetsDataArray[index].hidden) {
                visibleWidgets.push(this.widgetsDataArray[index]);
            }
        }
        return visibleWidgets;
    };

    WidgetsManagerViewController.prototype.getNumberOfActiveWidgets = function (widgetsArray, width) {
        var numberOfActiveWidgets = 0;
        var minWidth = width;
        calculateWidgetsForward(this, widgetsArray); // Calculating forward widgets if they can fit the screen.
        calculateWidgetsBackward(this, widgetsArray); // If reached the last widget and still has width, calculating previous widgets.

        if (this.startWidget < 0) {
            this.startWidget = 0;
        }

        return numberOfActiveWidgets;

        function calculateWidgetsForward(context, widgetsArray) {
            for (var i = context.startWidget; i < widgetsArray.length; i++) {
                delete widgetsArray[i].calculatedWidth;
                var widthNeeded = widgetsArray[i].minWidth + context.WIDGETS_PADDING;
                if ((widthNeeded > minWidth && minWidth >= context.DEFAULT_MIN_WIDTH)) {
                    numberOfActiveWidgets++;
                    widgetsArray[i].calculatedWidth = minWidth;
                }
                minWidth -= widthNeeded;
                if (minWidth >= 0) {
                    numberOfActiveWidgets++;
                }
            }
        }

        function calculateWidgetsBackward(context, widgetsArray) {
            if (minWidth > 0 && context.startWidget > 0) {
                var startFrom = Math.min(context.startWidget - 1, widgetsArray.length - 1);
                for (var i = startFrom; i >= 0; i--) {
                    delete widgetsArray[i].calculatedWidth;
                    var widthNeeded = widgetsArray[i].minWidth + context.WIDGETS_PADDING;
                    if ((widthNeeded > minWidth && minWidth >= context.DEFAULT_MIN_WIDTH)) {
                        context.startWidget--;
                        numberOfActiveWidgets++;
                        widgetsArray[i].calculatedWidth = minWidth;
                    }
                    minWidth -= (widgetsArray[i].minWidth + context.WIDGETS_PADDING);
                    if (minWidth >= 0) {
                        context.startWidget--;
                        numberOfActiveWidgets++;
                    }
                }
            }
        }
    };

    /**
     * This method checks if any of the widgets contained in this widget's type container is visible and will show/hide the container accordingly
     * @param widget
     */
    WidgetsManagerViewController.prototype.verifyContainerVisibility = function (widget) {
        var widgets = this.widgetsData[widget.applicationType].widgets;
        var isAnyWidgetVisible = false;
        for (var i = 0; i < widgets.length; i++) {
            if (widgets[i].visible) {
                isAnyWidgetVisible = true;
            }
        }
        if (isAnyWidgetVisible) {
            this.showWidgetContainer(widget.applicationType);
        } else {
            this.hideWidgetContainer(widget.applicationType);
        }
    };

    WidgetsManagerViewController.prototype.addWidgetContent = function (widget) {
        initializeWidgetSize(widget, this);
        this.setIconView(widget);
        addWidgetToCache(widget, this);
        addWidgetToWidgetContainer(widget, this);
        this.showWidget(widget);
        this.delayedLayoutWidgets(true);

        widget.onHide(this.verifyContainerVisibility, this);
        widget.onShow(this.verifyContainerVisibility, this);


        ////////////////////////////////////////////////////////////////////////////////////////////////
        //////////////////////////////// Private functions starts here /////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////
        function initializeWidgetSize(widget, context) {
            if (widget.span > 0) {
                widget.minWidth = (context.DEFAULT_MIN_WIDTH * widget.span) + ((widget.span - 1) * context.WIDGETS_PADDING);
                widget.maxWidth = (context.DEFAULT_MAX_WIDTH * widget.span) + ((widget.span - 1) * context.WIDGETS_PADDING);
            } else {
                widget.minWidth = widget.minWidth || context.DEFAULT_MIN_WIDTH;
                widget.maxWidth = widget.maxWidth || context.DEFAULT_MAX_WIDTH;
            }

            widget.widgetMultiplier = widget.maxWidth / context.DEFAULT_MAX_WIDTH;
        }

        function addWidgetToWidgetContainer(widget, context) {
            var contentArea = context.getFirstElement(context.LPViewMap.contentAreaAnimate); // The content area for all widgets.
            var contentAreaForWidget = context.getFirstElement("." + widget.applicationType, contentArea);
            if (!contentAreaForWidget) {
                //create a placeholder view according to widget type(custom or not)
                contentAreaForWidget = createWidgetFrame(context, widget, contentArea);

                context.lpHide(contentAreaForWidget);

                //update the widgetData dictionary
                context.widgetsData[widget.applicationType].contentArea = contentAreaForWidget;


                if (widget.configuration && widget.configuration.widgetConfig && widget.configuration.widgetConfig.hasRefresh) {
                    //binding  the refresh widget button to refreshWidget
                    context.bindViewEvent({
                        selector: '.button_right_pane_refresh',
                        DOMEvent: "click",
                        inView: contentAreaForWidget,
                        callback: context.refreshWidget,
                        lpEventData: {applicationType: widget.applicationType}
                    });
                }

                // binding the scroll to make sure it is restored in IE's as well
                context.bindViewEvent({
                    selector: context.LPViewMap.managedWidgetContent,
                    inView: contentAreaForWidget,
                    DOMEvent: "scroll",
                    callback: createScrollCallback(context, widget.applicationType)
                });
            }
            var managedWidgetContent = context.getFirstElement(context.LPViewMap.managedWidgetContent, contentAreaForWidget);
            context.addViewController({viewController : widget, target: managedWidgetContent});
        }

        function createWidgetFrame(context, widget, target) {
            var objectToInject;

            if (widget.configuration && widget.configuration.widgetConfig && widget.configuration.widgetConfig.isCustomWidget) {
                //if  the widget is customWidgets
                objectToInject = {
                    custom_widget: "custom_widget",
                    pilot_mode_cssClass: "pilot_mode",
                    custom_widget_icon_content: "custom_widget_icon_content",
                    iconText: lpUtils.initialsFromString(widget.configuration.widgetConfig.displayName),
                    description: widget.configuration.widgetConfig.description,
                    title: widget.configuration.widgetConfig.displayName
                };

            } else {

                objectToInject = {
                    custom_widget: '',
                    pilot_mode_cssClass: '',
                    custom_widget_refresh_button: '',
                    custom_widget_icon_content: widget.applicationType,
                    iconText: '',
                    description: '',
                    title: agentLEManager.translateLE("LEWebAgent." + widget.applicationType) || widget.applicationType
                };
            }

            if (widget.configuration && widget.configuration.widgetConfig && widget.configuration.widgetConfig.hasRefresh) {
                objectToInject.hasRefresh = 'has_refresh';
                if (widget.configuration.widgetConfig.refreshTooltip) {
                    objectToInject.refreshButtonTooltip = agentLEManager.translateLE("LEWebAgent." + widget.configuration.widgetConfig.refreshTooltip);
                } else {
                    objectToInject.refreshButtonTooltip = '';
                }
            } else {
                objectToInject.hasRefresh = '';
                objectToInject.refreshButtonTooltip = '';
            }

            objectToInject.iconCssClass = widget.icon ? widget.icon.firstChild.className : '';
            objectToInject.applicationType = widget.applicationType;

            return context.createView({
                templateFile: "LP_right_pane_widget.html",
                target: target,
                wrapWithDiv: false,
                textInjection: objectToInject
            });
        }

        function createScrollCallback(context, applicationType) {
            if (context && applicationType) {
                return function (e) {
                    context.widgetsData[applicationType].scrollPosition = context.widgetsData[applicationType].scrollPosition || {};
                    context.widgetsData[applicationType].scrollPosition[context.focusedVisitorId] = e.sourceElement.scrollTop;
                };
            }
        }

        function addWidgetToCache(widget, context) {
            var widgetData = context.widgetsData[widget.applicationType];

            if (!widgetData) {
                widgetData = {applicationType: widget.applicationType, widgets: []};
                context.widgetsDataArray.push(widgetData);
                context.widgetsData[widget.applicationType] = widgetData;
            }

            widgetData.minWidth = widget.minWidth;
            widgetData.maxWidth = widget.maxWidth;
            widgetData.widgetMultiplier = widget.widgetMultiplier;
            widgetData.widgets.push(widget);
        }
    };

    WidgetsManagerViewController.prototype.refreshWidget = function (data) {
        var widgets = this.widgetsData[data.lpEventData.applicationType].widgets;
        for (var i = 0; i < widgets.length; i++) {
            if ((widgets[i].visitorId === this.focusedVisitorId || widgets[i].visible) && widgets[i].configuration && widgets[i].configuration.refreshCallback) {
                widgets[i].configuration.refreshCallback();
            }
        }
    };

    WidgetsManagerViewController.prototype.setIconView = function (widget) {
        if (widget && widget.icon) {
            var buttonsArea = this.getFirstElement(this.LPViewMap.buttonsArea);
            var typeClass = widget.applicationType;
            var buttonSelected = false;
            var toggleButton = this.getFirstElement("." + widget.applicationType, buttonsArea);

            if (!toggleButton) {
                toggleButton = document.createElement("div");
                this.addClass(toggleButton, typeClass);

                buttonsArea.appendChild(toggleButton);
                this.bindViewEvent({view: toggleButton, callback: this.widgetSelected, lpEventData: widget, DOMEvent: "click"});
            } else {
                buttonSelected = this.hasSingleClass(toggleButton.firstChild, this.LPViewClasses.selected);
            }

            toggleButton.innerHTML = '';
            toggleButton.appendChild(widget.icon);
            if (buttonSelected) {
                this.addClass(toggleButton.firstChild, this.LPViewClasses.selected);
            }
            buttonsArea = null;

        }
    };

    WidgetsManagerViewController.prototype.lpShow = function (view, parentScope, animate) {
        ViewController.prototype.lpShow.call(this, view, parentScope, animate);

        if (!view || view === this.view) {
            var that = this;
            setTimeout(function () {
                that.delayedLayoutWidgets.call(that, true);
            }, 0);
        }
    };

    WidgetsManagerViewController.prototype.widgetSelected = function (data, onShowCallback) {
        this.startWidget = this.getWidgetIndex(data.lpEventData.applicationType);
        this.delayedLayoutWidgets(false, onShowCallback);
    };

    WidgetsManagerViewController.prototype.getWidgetIndex = function (applicationType) {
        var visibleWidgetsArr = this.getWidgetsForCurrentVisitor();
        for (var i = 0; i < visibleWidgetsArr.length; i++) {
            if (visibleWidgetsArr[i].applicationType === applicationType) {
                return i;
            }
        }
    };
    /**
     * This function handles the widget rendering on all its components and notify for its listeners.
     *
     * @param widgetContainer
     */
    WidgetsManagerViewController.prototype.showWidgetContent = function (widgetContainer) {
        if (!widgetContainer) {
            return;
        }
        var button = this.getFirstElement("." + widgetContainer.applicationType, this.LPViewMap.buttonsArea).firstChild;
        toggleWidgetButton(this);
        var contentArea = this.getFirstElement(this.LPViewMap.contentArea);
        var content = this.getFirstElement("." + widgetContainer.applicationType, contentArea);
        this.lpShow(content);
        var contentAreaView = this.getFirstElement(this.LPViewMap.managedWidgetContent, content);
        for (var i = 0; i < widgetContainer.widgets.length; i++) {
            if (widgetContainer.widgets[i].visible) {
                widgetContainer.widgets[i].notifyOnShow();
            }
        }
        widgetContainer.visible = true;
        if (widgetContainer.scrollPosition && widgetContainer.scrollPosition[this.focusedVisitorId]) {
            contentAreaView.scrollTop = widgetContainer.scrollPosition[this.focusedVisitorId];
        } else {
            contentAreaView.scrollTop = 0;
        }
        /**
         * This function handles the widget button inside the legend  - selected or not, enabled (for click) or not.
         *
         * @param context
         */
        function toggleWidgetButton(context) {
            var visibleWidgetsArr = context.getWidgetsForCurrentVisitor();
            var canMoveForward = _canMoveForward(context, visibleWidgetsArr);
            var canWidgetExpend = _canWidgetSpecificExpand(context, visibleWidgetsArr, widgetContainer);

        if (visibleWidgetsArr[context.startWidget].applicationType === widgetContainer.applicationType && !canWidgetExpend){
            context.addClass(button, context.LPViewClasses.disabled);
        }
        else if(canWidgetExpend || canMoveForward){
            context.removeClass(button, context.LPViewClasses.disabled);
        }else{
            context.addClass(button, context.LPViewClasses.disabled);
        }
        if (!context.hasSingleClass(button, context.LPViewClasses.selected)) {
            context.addClass(button, context.LPViewClasses.selected);
        }
    context.removeClass(button, context.LPViewClasses.notified);
        if(context.SdkNotificationOnWidgetExistForCurrentVisitor(widgetContainer.widgets)) {
            handleNotificationViewed(context);
        }
    }

    function handleNotificationViewed(context) {
        var chatId;
        if(context.engagementWidgets[context.focusedVisitorId][widgetContainer.applicationType]) {
            context.engagementWidgets[context.focusedVisitorId][widgetContainer.applicationType].hasSdkNotifications = false;
            chatId = context.engagementWidgets[context.focusedVisitorId][widgetContainer.applicationType].chatId;
        }

        lpTag.WebAgent.channel.publish(
            lpWebAgentStatics.COMMUNICATION_CHANNELS.AppEvents.name,
            lpWebAgentStatics.COMMUNICATION_CHANNELS.AppEvents.events.sdkNotificationViewed,
            {
                chatId: chatId,
                applicationType: widgetContainer.applicationType
            }
        );}
    };

    WidgetsManagerViewController.prototype.hideWidgetContent = function (widget) {
        var button = this.getFirstElement("." + widget.applicationType, this.LPViewMap.buttonsArea).firstChild;
        if(this.SdkNotificationOnWidgetExistForCurrentVisitor(widget.widgets)) {
            this.addClass(button, this.LPViewClasses.notified);
        }
        else {
            this.removeClass(button, this.LPViewClasses.notified);
        }

        if (typeof widget.visible !== 'undefined' && !widget.visible) {
            return;
        }

        if (this.hasSingleClass(button, this.LPViewClasses.selected)) {
            this.removeClass(button, [this.LPViewClasses.selected, this.LPViewClasses.disabled]);
        }

        var contentArea = this.getFirstElement(this.LPViewMap.contentArea);

        var content = this.getFirstElement("." + widget.applicationType, contentArea);
        this.lpHide(content);

        for (var i = 0; i < widget.widgets.length; i++) {
            if (widget.widgets[i].visible) {
                widget.widgets[i].notifyOnHide();
            }
        }
        widget.visible = false;
        contentArea = null;
    };

    WidgetsManagerViewController.prototype.hideWidgetContainer = function (widgetType) {
        this.setWidgetContainerVisibility(widgetType, false);
    };

    WidgetsManagerViewController.prototype.showWidgetContainer = function (widgetType) {
        this.setWidgetContainerVisibility(widgetType, true);
    };

    WidgetsManagerViewController.prototype.setWidgetContainerVisibility = function (widgetType, visible) {
        if (!this.widgetsData[widgetType] ||
            (visible && !this.widgetsData[widgetType].hidden ||
            !visible && this.widgetsData[widgetType].hidden)) {
            return;
        }
        this.widgetsData[widgetType].hidden = !visible;
        var method = visible ? "lpShow" : "lpHide";
        this[method](this.widgetsData[widgetType].contentArea);
        var button = this.getFirstElement("." + widgetType, this.LPViewMap.buttonsArea);
        this[method](button);
        this.delayedLayoutWidgets(true);
    };

    WidgetsManagerViewController.prototype.showWidget = function (widget) {
        var widgetsArray = this.widgetsData[widget.applicationType].widgets;
        if (widgetsArray.length > 1) {
            var i;
            for (i = 0; i < widgetsArray.length; i++) {
                if (widgetsArray[i].placeholderWidget) {
                    widgetsArray[i].lpHide();
                }
            }
        }
    };

    WidgetsManagerViewController.prototype.statusChanged = function (data) {
        if (data.newValue !== 'loggedIn' && typeof data.newValue !== 'undefined') {
            this.dispose();
        }
    };

    WidgetsManagerViewController.prototype.loadDynamicWidget = function (evt) {
        this.showDialog({
            title: agentLEManager.translateLE("LEWebAgent.loadWidgetTitle"), // TODO: Should we have an input field as part of the dialogs (hidden by default
            description: agentLEManager.translateLE("LEWebAgent.loadWidgetURL") + "<br/><input type='text' style='position: relative; height: 25px; width: 100%; margin-top: 7px;'/>",
            okButton: agentLEManager.translateLE("LEWebAgent.ok"),
            cancelButton: agentLEManager.translateLE("LEWebAgent.cancel"),
            defaultOk: true,
            okCallback: this.loadDynamicWidgetOkClicked,
            targetView: window.MainViewControllerBody,
            modal: true,
            onInitialize: onDialogRender
        });

        var that = this;
        function onDialogRender() {
            var input = that.getFirstElement("input", that.dialogViewController.view);
            input.focus();
            input = null;
        }
    };


///////////////// Private functions //////////////////
    /**
     * Determines if it's possible to move forward in the widgets display.
     * @param context The widgets manager
     * @param widgetsArray The array of visible widgets
     * @returns {boolean} If true - the right arrow and right most widget button should be enabled and clickable.
     * @private
     */
    function _canMoveForward(context, widgetsArray) {
        // we check if their is more widgets to show , or if the last widget can be expand
        return (context.endWidget < widgetsArray.length && context.visibleWidgetsCount < widgetsArray.length) || _canLastWidgetExpand(context, widgetsArray);
    }

    /**
     * Determines if it's possible to move back in the widgets display.
     * @param context The widgets manager
     * @param widgetsArray The array of visible widgets
     * @returns {boolean} If true - the left arrow and left most widget button should be enabled and clickable.
     * @private
     */
    function _canMoveBack(context, widgetsArray) {
        return context.startWidget > 0 && context.visibleWidgetsCount < widgetsArray.length;
    }

    /**
     * Checks if last widget can expand (if he supposed to be larger than their current size).
     * @param context The widgets manager
     * @param widgetsArray The array of visible widgets
     * @returns {boolean} True if any of the current widgets has a higher multiplier (size) than what is currently shown.
     * @private
     */
    function _canLastWidgetExpand(context, widgetsArray) {
        var widget = widgetsArray[context.endWidget - 1];

        if (widget && widget.widgetMultiplier > 1) {
            var amountOfActualWidgets = _getWidgetsMultipliers(context, widgetsArray);
            var contentWidth = _getContentWidth(context);
            var singleWidgetWidth = _getSingleWidgetWidth(context, contentWidth, context.visibleWidgetsCount, amountOfActualWidgets);
            var isMax = false;
            if (widget.actualWidth === widget.maxWidth) {
                isMax = true;
            }
            if (widget && widget.widgetMultiplier && widget.actualWidth && !isMax) {
                if (widget.actualWidth < widget.widgetMultiplier * singleWidgetWidth) {
                    return true;
                }
            }
            return false;
        }
    }
    /**
     * Checks if Specific widget can expand (if he supposed to be larger than their current size).
     * @param context The widgets manager
     * @param widgetsArray The array of visible widgets
     * @param widgetContiner the widget continer
     * @returns {boolean} True if any of the current widgets has a higher multiplier (size) than what is currently shown.
     * @private
     */
    function _canWidgetSpecificExpand(context, widgetsArray, widgetContiner) {
        var amountOfActualWidgets = _getWidgetsMultipliers(context, widgetsArray);
        var contentWidth = _getContentWidth(context);
        var singleWidgetWidth = _getSingleWidgetWidth(context, contentWidth, context.visibleWidgetsCount, amountOfActualWidgets);
        if (widgetContiner && widgetContiner.widgetMultiplier && widgetContiner.actualWidth && context.visibleWidgetsCount !== 1) {
            if (widgetContiner.actualWidth < widgetContiner.widgetMultiplier * singleWidgetWidth && widgetContiner.widgetMultiplier > 1) {
                return true;
            }
        }
        return false;
    }

    /**
     * Gets the total sum of the visible widget multipliers. For example, if a double sized widget and a triple sized
     * widget are currently displayed - the result would be 5.
     * @param context The widgets manager
     * @param widgetsArray The array of visible widgets
     * @returns {number} The sum of the multipliers of the visible widgets.
     * @private
     */
    function _getWidgetsMultipliers(context, widgetsArray) {
        var amountOfActualWidgets = 0;
        for (var i = context.startWidget; i < context.endWidget; i++) {
            var widget = widgetsArray[i];
            amountOfActualWidgets += widget.widgetMultiplier;
        }

        return amountOfActualWidgets;
    }

    /**
     * Gets the width of the widgets area.
     * @param context The widgets manager
     * @returns {number|a.getScrollInfo.clientWidth|*|window.CodeMirror.getScrollInfo.clientWidth} The width of the widgets
     * area.
     * @private
     */
    function _getContentWidth(context) {
        var contentArea = context.getFirstElement(context.LPViewMap.contentArea);
        var width = contentArea.clientWidth;
        if (width !== 'auto') {
            width = parseInt(width, 10);
        } else {
            width = -1;
        }

        contentArea = null;
        return width;
    }

    /**
     * Gets the width for a single widget
     * @param context The widgets manager
     * @param contentWidth The width of the widgets area
     * @param numberOfActiveWidgets The number of visible widgets
     * @param amountOfActualWidgets The sum of the multipliers of the visible widgets
     * @returns {number} The width of a single widget
     * @private
     */
    function _getSingleWidgetWidth(context, contentWidth, numberOfActiveWidgets, amountOfActualWidgets) {
        return (contentWidth - (numberOfActiveWidgets * context.WIDGETS_PADDING)) / amountOfActualWidgets;
    }

    return WidgetsManagerViewController;

});
